import { collection } from "firebase/firestore";
import { firestore } from "../../../firebase/firebase";
import { applicationsPath } from "../../../firebase/applications/appsPath";

const getCommentsSubCollRef = (appId, applicantId, sectionId) => {
  const path = `${applicationsPath.applications}/${appId}/documents/${applicantId}/docSections/${sectionId}/docsSectionComments`;
  return collection(firestore, path);
}

export default getCommentsSubCollRef;